import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

type Service = "groepenkast" | "camerabewaking" | "laadpaal";
interface QuoteRequestFormProps {
  service: Service; title?: string; subtitle?: string; submitLabel?: string; prefillSessionKey?: string;
}
// Legacy form entrypoints now lead to the same browser-only request wizard.
export function QuoteRequestForm({ service, title = "Offerte op maat", submitLabel = "Offerte aanvragen" }: QuoteRequestFormProps) {
  return <section className="space-y-5 rounded-lg border border-border bg-card p-6 sm:p-8">
    <h2 className="text-2xl tracking-normal">{title}</h2>
    <Button asChild size="lg" className="w-full"><Link to="/offerte-aanvragen" search={{ product: service }}>{submitLabel}<ArrowRight /></Link></Button>
  </section>;
}
